import SearchResultLayout from './SearchResultLayout'
import SearchResultLogic from './SearchResultLogic'

const SearchResult = () => {
  return <SearchResultLogic Wrapper={SearchResultLayout} />
}

export default SearchResult
